/**
 * In this example the LightTheme colors have been edited. We would not recommend using this color scheme in production, but hopefully
 * it helps demonstrate some of the customizations that are possible and the power of the Material UI.
 *
 * Another powerful feature of Material UI is the ability to use the framework to pick complementary colors. This feature is not exploited
 * in this example. Instead, many colors from the rainbow are forced onto the UI.
 *
 * Some useful links for working with themes can be found at:
 * https://themes.material-ui.com/
 * https://material-ui.com/customization/default-theme/ //Will show all the properties you can edit
 * https://material.io/resources/color/#!/?view.left=0&view.right=0&primary.color=c24f00&secondary.color=214563 //great for color selecting
 */

import { ThemeOptions } from '@material-ui/core';
import { defaultDarkTheme, AlmeTheme } from '../../../models/AlmeTheme';

const palette = {
    background: {
        paper: '#856088', //effects individual messages
        default: '#9400d3', //effects the main body of the IVA
    },
};
const lightModeTheme = { palette } as ThemeOptions;

export const appThemeMain = {
    lightTheme: lightModeTheme,
    darkTheme: defaultDarkTheme,
} as AlmeTheme;
